import { SystemsClient } from "../api/swagger/ApiClient";
import { ServiceBase } from "../support/base_classes/service-base";
import { autoinject } from 'aurelia-framework';
import { DialogHelper } from "../framework/aurelia_dialogs/dialog-helper";

@autoinject
export class FeatureService extends ServiceBase {
  apiVersion?: string;
  dbVersion?: string;
  contactPhoneNumber?: string;
  contactEmail?: string;
  contactWebUrl?: string;
  private interval: NodeJS.Timeout;
  private isApiVersionCheckSent: boolean = false;

  constructor(private client: SystemsClient, private dialogHelper: DialogHelper) {
    super();
  }

  protected async initializeService() {
    await this.reload();
    this.startCheckApiVersionInterval();
  }

  private async reload() {
    const features = await this.client.getFeatures();
    this.apiVersion = features.apiVersion;
    this.contactPhoneNumber = features.contactPhoneNumber;
    this.contactEmail = features.contactEmail;
    this.contactWebUrl = features.contactWebUrl;
  }

  private async checkApiVersion() {
    if (!this.isApiVersionCheckSent) {
      this.isApiVersionCheckSent = true;
      this.client.getApiVersion()
        .then(async (actualVersion: string) => {
          if (actualVersion != null && actualVersion != this.apiVersion) {
            clearInterval(this.interval);
            const message: string = `A new application version ${actualVersion} has been deployed to the server. Please refresh browser window by pressing F5 key or "Reload now" button.\n\nPlease note you'll lost all unsaved data once refreshed.`;
            if (await this.dialogHelper.confirm({ dialogTitle: 'New version available!', message: message, okTitle: 'Reload now', cancelTitle: 'Later' })) {
              window.location.reload();
            } else {
              this.startCheckApiVersionInterval();
            }
          }
          this.isApiVersionCheckSent = false;
        })
        .catch(error => {
          console.log(error);
          this.isApiVersionCheckSent = false;
        });
    }           
  }

  private startCheckApiVersionInterval() {
    this.interval = setInterval(() => this.checkApiVersion(), 30000);
  }
}
